import { render, staticRenderFns } from "./RenewalAction.vue?vue&type=template&id=656b33a7"
import script from "./RenewalAction.vue?vue&type=script&lang=js"
export * from "./RenewalAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports